// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.values-list__values-container {
  flex: 1;
  width: 50%;
  overflow: hidden;
  overflow-y: auto;
  border-right: 1px solid var(--g-color-line-generic);
}
.values-list__error-label {
  margin: var(--g-spacing-4);
}
.values-list__values-search {
  padding: 20px 32px 0;
}
.values-list__values-list {
  margin-top: 10px;
  position: relative;
  height: calc(100% - 58px);
  overflow-y: auto;
}
.values-list__value {
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  padding-left: 32px;
  cursor: pointer;
}
.values-list__value:not(.values-list__value_selected):hover {
  background-color: var(--g-color-base-simple-hover);
}
.values-list__value_selected {
  background-color: var(--g-color-base-selection);
}
.values-list__value-label {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.values-list__loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/ValuesList/ValuesList.scss"],"names":[],"mappings":"AACI;EACI,OAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mDAAA;AAAR;AAGI;EACI,0BAAA;AADR;AAII;EACI,oBAAA;AAFR;AAKI;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAHR;AAMI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAJR;AAMQ;EACI,kDAAA;AAJZ;AAOQ;EACI,+CAAA;AALZ;AASI;EACI,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAPR;AAUI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AARR","sourcesContent":[".values-list__values-container {\n  flex: 1;\n  width: 50%;\n  overflow: hidden;\n  overflow-y: auto;\n  border-right: 1px solid var(--g-color-line-generic);\n}\n.values-list__error-label {\n  margin: var(--g-spacing-4);\n}\n.values-list__values-search {\n  padding: 20px 32px 0;\n}\n.values-list__values-list {\n  margin-top: 10px;\n  position: relative;\n  height: calc(100% - 58px);\n  overflow-y: auto;\n}\n.values-list__value {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 32px;\n  padding-left: 32px;\n  cursor: pointer;\n}\n.values-list__value:not(.values-list__value_selected):hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.values-list__value_selected {\n  background-color: var(--g-color-base-selection);\n}\n.values-list__value-label {\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.values-list__loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
